import { Component, ElementRef, Input, OnInit, ViewChild } from "@angular/core";
import { NbDialogRef } from "@nebular/theme";
import { EColumnType } from "../../table/EColumnType";
import { EAcaoType } from "../../../enums/EAcaoType";

@Component({
  selector: "ngx-modal-acao",
  templateUrl: "./modal-acao.component.html",
  styleUrls: ["./modal-acao.component.scss"],
})
export class ModalAcaoComponent implements OnInit {
  @ViewChild("modalAcao", { static: false })
  private modalAcao: ElementRef;

  @Input() data: {
    title: string;
    messageFooter: string;
    acaoType: EAcaoType;
    textButtonCancel?: string;
    textButtonConfirm?: string;
    data: { label: string; value: any; type: EColumnType; enumMap?: any }[];
  };

  showButtons: boolean = true;

  constructor(protected ref: NbDialogRef<ModalAcaoComponent>) {}

  ngOnInit(): void {
    if (this.modalAcao && this.modalAcao.nativeElement) {
      this.modalAcao.nativeElement.ownerDocument.activeElement.blur();
    }

    this.showButtons = this.data.acaoType !== EAcaoType.INFORMAR;
  }

  close() {
    this.ref.close();
  }

  confirm() {
    this.ref.close(true);
  }

  getTitleColor() {
    if (this.data.acaoType === EAcaoType.CANCELAR) {
      return "#DC3545";
    }

    return "#000";
  }

  getButtonColor() {
    if (this.data.acaoType === EAcaoType.CANCELAR) {
      return {
        confirm: "#DC3545",
        cancel: "#666",
      };
    }

    return null;
  }
}
